import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InlineField } from "../private/InlineField/InlineField.mjs";
import { validTabIndexes } from "../private/validateTabIndex.mjs";
import { resolveCheckedGroup } from "./resolveCheckedGroup.mjs";
const Checkbox = forwardRef(
  ({ checked, tabIndex, ...restProps }, ref) => {
    const calculatedChecked = Array.isArray(checked) ? resolveCheckedGroup(checked) : checked;
    return /* @__PURE__ */ jsx(
      InlineField,
      {
        ...restProps,
        tabIndex: validTabIndexes.includes(tabIndex) ? tabIndex : void 0,
        checked: calculatedChecked,
        type: "checkbox",
        ref
      }
    );
  }
);
Checkbox.displayName = "Checkbox";
export {
  Checkbox
};
